import SelectContext from './SelectContext'

const SelectConsumer = SelectContext.Consumer ;

export default SelectConsumer ;